import { RuntimeError } from './RuntimeError';
export class UnsupportedError extends RuntimeError {
    constructor(message, options) {
        super(message, options);
        this.name = 'bytereplay.core.UnsupportedError';
    }
}
